import React from 'react'

import { GrowthFigures } from './GrowthFigures'
import { LatestRefefinanceIndex } from './LatestRefinanceIndex'
import { GrowthFiguresInt, growthPeriods } from '../../constants/GrowthFigures'

import './growth-figures.css'

export interface GrowthFiguresBarProps {
  growthFigureData: GrowthFiguresInt
  indexDetailType: string
  isAvailable: boolean
}

export const GrowthFiguresBar: React.FC<GrowthFiguresBarProps> = ({
  growthFigureData,
  indexDetailType,
  isAvailable,
}) => {
  return (
    <div className="growth-figures-bar">
      <LatestRefefinanceIndex
        growthFigureData={growthFigureData}
        indexDetailType={indexDetailType}
        isAvailable={isAvailable}
      />

      <div className="growth-figures-container">
        <GrowthFigures period={growthPeriods.week} data={growthFigureData.change_week} isAvailable={isAvailable} />
        <GrowthFigures period={growthPeriods.month} data={growthFigureData.change_month} isAvailable={isAvailable} />
        <GrowthFigures
          period={growthPeriods.quarter}
          data={growthFigureData.change_quarter}
          isAvailable={isAvailable}
        />
        <GrowthFigures period={growthPeriods.year} data={growthFigureData.change_year} isAvailable={isAvailable} />
      </div>
    </div>
  )
}
